import type { FileContentType } from '../apis/file-delete-api';

/**
 * 文件删除服务接口
 */
export const FileDeleteService = Symbol.for('FileDeleteService');

/**
 * 文件删除服务接口
 */
export interface FileDeleteService {
    /**
     * 删除文件
     * @param taskId 任务ID
     * @param contentType 文件类型
     * @returns 删除是否成功
     */
    deleteFile(taskId: string, contentType: FileContentType): Promise<boolean>;
}
